import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from '@angular/common';
import { ApiService, HelperService, MetaService } from "@app/core"

@Component({
    selector: 'app-view-knowledge-base',
    templateUrl: './view-knowledge-base.component.html',
    standalone: false
})
export class ViewKnowledgeBaseComponent implements OnInit {

  fragmentEl: any;
  data: any = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private helperService: HelperService,
    private metaservice: MetaService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.activatedRoute.fragment.subscribe(frameElement => {
      this.fragmentEl = frameElement
      this.redirectToHash();
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.data.tag = (params['tag']) ? params['tag'] : '';
      this.data.search = (params['search']) ? params['search'] : '';
    });
    this.getBySlug(this.activatedRoute.snapshot.params.slug);
  }

  ngOnInit(): void {

    /*
     # Appending CKEditor js on runtime because it contain the styling  details (css classes).
     # Also we donot want to load this on everypage So appending while loading the page.
   */

    let library = '/assets/js/ckeditor/ckeditor.js';

    if (isPlatformBrowser(this.platformId)) {
      if (document.querySelectorAll('[src="' + library + '"]').length == 0) {
        const script1 = document.createElement('script');
        script1.async = true;
        script1.src = library;
        document.head.appendChild(script1);
      }
    }
  }

  getBySlug(slug: string) {
    this.helperService.blockUI();
    this.apiService.get('knowledge-base/' + slug).subscribe((res: any) => {
      this.data.knowledgeBaseArticle = res;
      this.metaservice.updateTitle(this.data.knowledgeBaseArticle.title + ' | Knowledge Base | StartDeck');
      this.metaservice.updateMetaDescription(this.data.knowledgeBaseArticle.description);
      this.helperService.unBlockUI();
      this.redirectToHash();
    });
  }

  redirectToHash() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        if (this.fragmentEl) {
          var element: any = document.getElementById(this.fragmentEl);

          if (element != null) {
            window.scroll(0,element.offsetTop - 80);
          }
        }
      }, 1000);
    }
  }

  redirectToKB() {
    this.helperService.navigateToUrl('/knowledge-base?tag=' + this.data.tag + '&search=' + this.data.search);
  }
}
